// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDq4lWpJhZEQhox66tTv3vEwwWe1w-AQdk",
    authDomain: "developer-api-cloud-endpoint.firebaseapp.com",
    projectId: "developer-api-cloud-endpoint",
    storageBucket: "developer-api-cloud-endpoint.appspot.com",
    messagingSenderId: "695371545442",
    appId: "1:695371545442:web:4e171c4c54fbd30c310a3b"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
